import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import getActiveRoute from './getActiveRoute';
import { useOnErrorHandler } from '../../../common';

function useGetActiveRoute({ routeType }) {
  const { username: id_clouder } = useSelector((store) => store.auth);

  const query = useQuery({
    queryKey: ['getActiveRoute', id_clouder, routeType],
    queryFn: () => getActiveRoute({ idClouder: id_clouder, routeType }),
    enabled: !!id_clouder && !!routeType,
  });

  useOnErrorHandler({ query });

  return query;
}

export default useGetActiveRoute;
